var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendiente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fab51c;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 15,
    r: 14.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,23.4c-.7,0-1.2-.2-1.6-.6-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5c.4-.4,1-.6,1.6-.6s1.2.2,1.7.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5c-.4.4-1,.6-1.7.6ZM13.5,17.4l-.7-10.9h4.4l-.7,10.9h-2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendiente);
export default __webpack_public_path__ + "static/media/pendiente.6cdeb22d21675e4298530d06415e84da.svg";
export { ForwardRef as ReactComponent };